// Search engines and AI search tools: each page sets its own title,
// description, canonical link and (optionally) structured data (JSON-LD,
// schema.org). index.html carries the defaults for crawlers that don't run
// JavaScript.
import { useEffect } from "react";

const SITE = "PawBazaar";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
}

export function useSeo({ title, description, path, jsonLd, image } = {}) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!title) return undefined;
    const full = title.includes(SITE) ? title : `${title} | ${SITE}`;
    document.title = full;
    setMeta("property", "og:title", full);
    setMeta("name", "twitter:title", full);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (image) setMeta("property", "og:image", image);
    const url = `${window.location.origin}${path ?? window.location.pathname}`;
    setMeta("property", "og:url", url);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = url;
    let script = null;
    if (ld) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.page = "1";
      script.text = ld;
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, path, ld, image]);
}
